/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1DestinationAllocation } from '../models/V1DestinationAllocation';
import { HttpFile } from '../http/http';

/**
* Cross-destination impression allocation state for an order line. When unset/null on the OrderLine, single-destination behavior is used. Auto-initialized when a deployment destination configuration is created or updated, with the single destination receiving 100%.
*/
export class V1Distribution {
    /**
    * Destination-level impression allocations. Must contain one or more allocations. Allocated impressions must sum to the order line's total impressions. Going from two allocations to one is blocked if the dropped destination has served impressions > 0.
    */
    'allocations'?: Array<V1DestinationAllocation>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "allocations",
            "baseName": "allocations",
            "type": "Array<V1DestinationAllocation>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1Distribution.attributeTypeMap;
    }

    public constructor() {
    }
}

